import { prop, pipe, curry } from 'ramda';
import toMaybe from './toMaybe';

const maybeProp = curry(
  (propToFind, obj) =>
    pipe(prop, toMaybe)(propToFind, obj)
);

export default maybeProp;
